import React, { forwardRef } from 'react';
import MenuExpandIcon from '@atlaskit/icon/glyph/menu-expand';
import type { TriggerProps } from '@atlaskit/popup';
import { ThemedButton } from '@atlassian/jira-business-theme-components';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import { useGetGroupByField } from '../../../../../controllers/get-group-by-field';
import { useGroupBy } from '../../../../../controllers/group-by';
import messages from './messages';

const GROUP_ICON = <MenuExpandIcon label="" size="small" />;

type Props = Partial<Omit<TriggerProps, 'ref'>> & { isSelected: boolean; onClick: () => void };

const Trigger = forwardRef<HTMLDivElement, Props>(
	({ onClick, isSelected, ...otherProps }: Props, ref) => {
		const { formatMessage } = useIntl();
		const [groupByFieldId] = useGroupBy();

		const groupByField = useGetGroupByField();

		return (
			<div ref={ref} {...otherProps}>
				<ThemedButton
					testId="business-list.ui.list-view.header-actions.group-by-dropdown.trigger.button-wrapper"
					iconBefore={GROUP_ICON}
					isSelected={isSelected}
					onClick={onClick}
					appearance="subtle"
				>
					{groupByFieldId == null ? (
						formatMessage(messages.groupByButton)
					) : (
						<FormattedMessage
							{...messages.groupByActiveButton}
							values={{
								groupByFieldId: groupByField?.name,
							}}
						/>
					)}
				</ThemedButton>
			</div>
		);
	},
);

export default Trigger;
